import React, { Component } from "react";
export default class Header extends React.Component {
    constructor(props){
        super(props)
    }
    render(){

        return (
            <header className="header">
                <h3> Welcome SV redux 4.3.1 with hooks</h3>
            </header>
        )
    }
}